(function () {
  'use strict';

  const MOBILE_HERO_BREAKPOINT = 989;

  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  const resolveCountdownEnd = (el) => {
    const fixedEnd = el.dataset.end;
    if (fixedEnd) {
      const parsed = Date.parse(fixedEnd);
      if (!Number.isNaN(parsed)) return parsed;
    }

    const storageKey = `wig-bs-end-${el.dataset.sectionId}`;
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        const storedMs = Number(stored);
        if (!Number.isNaN(storedMs) && storedMs > Date.now()) return storedMs;
      }
    } catch (err) {
      /* ignore storage errors */
    }

    const hours = Number(el.dataset.durationHours) || 24;
    const endMs = Date.now() + hours * 3600000;
    try {
      localStorage.setItem(storageKey, String(endMs));
    } catch (err) {
      /* ignore storage errors */
    }
    return endMs;
  };

  const tickCountdown = (el, endMs) => {
    const remainingMs = Math.max(0, endMs - Date.now());
    const totalSeconds = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    el.querySelector('[data-wig-bs-days]').textContent = pad(days);
    el.querySelector('[data-wig-bs-hours]').textContent = pad(hours);
    el.querySelector('[data-wig-bs-mins]').textContent = pad(mins);
    el.querySelector('[data-wig-bs-secs]').textContent = pad(secs);
  };

  const bindCountdown = (el) => {
    if (!el || el.dataset.countdownBound === 'true') return;
    el.dataset.countdownBound = 'true';
    const endMs = resolveCountdownEnd(el);
    tickCountdown(el, endMs);
    window.setInterval(() => tickCountdown(el, endMs), 1000);
  };

  const initBestSellersCountdown = (scope = document) => {
    scope.querySelectorAll('[data-wig-bs-countdown]').forEach(bindCountdown);
  };

  window.WigBestSellers = { initCountdown: initBestSellersCountdown };

  initBestSellersCountdown();

  const syncHeroMobileMedia = (scope = document) => {
    const heroes = scope.matches?.('[data-wig-hero].wig-hero--has-mobile-image')
      ? [scope]
      : [...scope.querySelectorAll('[data-wig-hero].wig-hero--has-mobile-image')];

    heroes.forEach((hero) => {
      const breakpoint = Number(hero.dataset.heroMobileBreakpoint) || MOBILE_HERO_BREAKPOINT;
      const width = hero.getBoundingClientRect().width;
      hero.classList.toggle('is-hero-mobile-view', width > 0 && width <= breakpoint);
    });
  };

  const bindHeroMobileMedia = (hero) => {
    if (!hero || hero.dataset.heroMobileBound === 'true') return;
    hero.dataset.heroMobileBound = 'true';
    syncHeroMobileMedia(hero);

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => syncHeroMobileMedia(hero));
      observer.observe(hero);
    }
  };

  const initHeroMobileMedia = (scope = document) => {
    const heroes = scope.matches?.('[data-wig-hero].wig-hero--has-mobile-image')
      ? [scope]
      : scope.querySelectorAll('[data-wig-hero].wig-hero--has-mobile-image');
    heroes.forEach(bindHeroMobileMedia);
    syncHeroMobileMedia(scope);
  };

  window.WigHeroMedia = { sync: syncHeroMobileMedia, init: initHeroMobileMedia };

  initHeroMobileMedia();
  window.addEventListener('resize', () => syncHeroMobileMedia(), { passive: true });
  window.addEventListener('orientationchange', () => syncHeroMobileMedia(), { passive: true });

  document.querySelector('[data-hero-video-toggle]')?.addEventListener('click', () => {
    const video = document.querySelector('.wig-hero__video');
    const mutedIcon = document.querySelector('[data-hero-muted-icon]');
    const unmutedIcon = document.querySelector('[data-hero-unmuted-icon]');
    if (!video) return;
    video.muted = !video.muted;
    if (mutedIcon) mutedIcon.hidden = !video.muted;
    if (unmutedIcon) unmutedIcon.hidden = video.muted;
  });

  const visibleCards = (track) => [...track.querySelectorAll('[data-ugc-card]')].filter((card) => !card.hidden);

  const getActiveCardIndex = (track) => {
    const cards = visibleCards(track);
    if (!cards.length) return 0;
    const trackRect = track.getBoundingClientRect();
    const trackCenter = trackRect.left + trackRect.width / 2;
    let bestIndex = 0;
    let bestDistance = Infinity;

    cards.forEach((card, index) => {
      const rect = card.getBoundingClientRect();
      const cardCenter = rect.left + rect.width / 2;
      const distance = Math.abs(cardCenter - trackCenter);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });

    return bestIndex;
  };

  const scrollToCard = (track, index) => {
    const cards = visibleCards(track);
    const card = cards[index];
    if (!card) return;
    track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  };

  const isMobileUgc = () => window.matchMedia('(max-width: 767px)').matches;

  const ensureDots = (root, track) => {
    const dotsWrap = root.querySelector('[data-ugc-dots]');
    if (!dotsWrap) return null;

    const cards = visibleCards(track);
    if (!isMobileUgc() || cards.length <= 1) {
      dotsWrap.innerHTML = '';
      dotsWrap.classList.add('is-hidden');
      dotsWrap.dataset.count = '0';
      dotsWrap.setAttribute('aria-hidden', 'true');
      return dotsWrap;
    }

    dotsWrap.classList.remove('is-hidden');
    dotsWrap.setAttribute('aria-hidden', 'false');
    if (dotsWrap.dataset.count === String(cards.length)) return dotsWrap;

    dotsWrap.innerHTML = '';
    cards.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'wig-ugc__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', `Show clip ${index + 1} of ${cards.length}`);
      dot.addEventListener('click', () => scrollToCard(track, index));
      dotsWrap.appendChild(dot);
    });
    dotsWrap.dataset.count = String(cards.length);
    return dotsWrap;
  };

  const updateDots = (root, track) => {
    const dotsWrap = ensureDots(root, track);
    if (!dotsWrap || dotsWrap.classList.contains('is-hidden')) return;
    const activeIndex = getActiveCardIndex(track);
    dotsWrap.querySelectorAll('.wig-ugc__dot').forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  };

  const trackOverflows = (track) => {
    if (!track) return false;
    const cards = visibleCards(track);
    if (!cards.length) return false;
    const gap = 16;
    const totalWidth = cards.reduce((sum, card) => sum + card.getBoundingClientRect().width, 0)
      + gap * Math.max(0, cards.length - 1);
    return totalWidth > track.clientWidth + 2;
  };

  const updateNav = (root) => {
    const carousel = root?.querySelector('[data-ugc-carousel]');
    if (!carousel) return;
    const track = carousel.querySelector('[data-ugc-track]');
    const prevBtn = carousel.querySelector('[data-ugc-prev]');
    const nextBtn = carousel.querySelector('[data-ugc-next]');
    if (!track || !prevBtn || !nextBtn) return;

    const overflow = trackOverflows(track);
    prevBtn.classList.toggle('is-hidden', !overflow);
    nextBtn.classList.toggle('is-hidden', !overflow);
    prevBtn.disabled = !overflow || track.scrollLeft <= 2;
    nextBtn.disabled = !overflow || track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    updateDots(root, track);
  };

  const scrollTrack = (track, dir) => {
    if (!track) return;
    const card = visibleCards(track)[0];
    const gap = 16;
    const amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.85;
    track.scrollLeft += dir * amount;
    window.setTimeout(() => updateNav(track.closest('.wig-home-ugc, .wig-product-ugc')), 50);
  };

  const bindSection = (root) => {
    if (!root || root.dataset.ugcBound === 'true') return;

    const carousel = root.querySelector('[data-ugc-carousel]');
    const track = root.querySelector('[data-ugc-track]');
    if (!carousel || !track) return;

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-ugc-prev]')) {
        event.preventDefault();
        event.stopPropagation();
        scrollTrack(track, -1);
        return;
      }

      if (event.target.closest('[data-ugc-next]')) {
        event.preventDefault();
        event.stopPropagation();
        scrollTrack(track, 1);
        return;
      }

      const filter = event.target.closest('[data-ugc-filter]');
      if (!filter) return;

      event.preventDefault();
      const filterValue = filter.dataset.ugcFilter;
      root.querySelectorAll('[data-ugc-filter]').forEach((btn) => {
        btn.classList.toggle('is-active', btn === filter);
        btn.setAttribute('aria-selected', btn === filter ? 'true' : 'false');
      });
      root.querySelectorAll('[data-ugc-card]').forEach((card) => {
        const tags = card.dataset.ugcTags || '';
        card.hidden = filterValue !== 'all' && tags !== filterValue;
      });
      track.scrollLeft = 0;
      window.setTimeout(() => updateNav(root), 50);
    });

    track.addEventListener('scroll', () => updateNav(root), { passive: true });

    const drag = { active: false, moved: false, startX: 0, startY: 0, scrollLeft: 0, pointerId: null };
    const isHomeUgcTouch = (event) =>
      root.classList.contains('wig-home-ugc') && (event.pointerType === 'touch' || isMobileUgc());

    track.addEventListener('pointerdown', (event) => {
      if (event.target.closest('video, button, a, input, label')) return;
      /* Mobile Home UGC: native overflow-x + pan-y so the page can still scroll vertically */
      if (isHomeUgcTouch(event)) return;
      drag.active = true;
      drag.moved = false;
      drag.startX = event.clientX;
      drag.startY = event.clientY;
      drag.scrollLeft = track.scrollLeft;
      drag.pointerId = event.pointerId;
    });

    track.addEventListener('pointermove', (event) => {
      if (!drag.active || event.pointerId !== drag.pointerId) return;
      const deltaX = event.clientX - drag.startX;
      const deltaY = event.clientY - drag.startY;
      if (!drag.moved && Math.abs(deltaX) > 6) {
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          drag.active = false;
          return;
        }
        drag.moved = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      }
      if (drag.moved) {
        event.preventDefault();
        track.scrollLeft = drag.scrollLeft - deltaX;
      }
    });

    const endDrag = (event) => {
      if (!drag.active || event.pointerId !== drag.pointerId) return;
      drag.active = false;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      updateNav(root);
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => updateNav(root));
      observer.observe(track);
      cardsLoadedObserver(root, track, () => updateNav(root));
    }

    root.dataset.ugcBound = 'true';
    requestAnimationFrame(() => updateNav(root));
    window.setTimeout(() => updateNav(root), 300);
    window.setTimeout(() => updateNav(root), 1200);
  };

  const cardsLoadedObserver = (root, track, callback) => {
    track.querySelectorAll('video, img').forEach((el) => {
      if (el.complete || el.readyState >= 2) return;
      el.addEventListener('loadeddata', callback, { once: true });
      el.addEventListener('load', callback, { once: true });
    });
  };

  const initHomeUgc = (scope = document) => {
    const roots = new Set();
    if (scope.matches?.('.wig-home-ugc, .wig-product-ugc')) roots.add(scope);
    scope.querySelectorAll('.wig-home-ugc, .wig-product-ugc').forEach((el) => roots.add(el));
    roots.forEach(bindSection);
  };

  window.WigHomeUgc = { initSection: bindSection, initAll: initHomeUgc };

  initHomeUgc();

  window.addEventListener('resize', () => {
    initHomeUgc();
    document.querySelectorAll('.wig-home-ugc[data-ugc-bound], .wig-product-ugc[data-ugc-bound]').forEach((root) => {
      const track = root.querySelector('[data-ugc-track]');
      if (track) updateNav(root);
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initHomeUgc(event.target);
    initHeroMobileMedia(event.target);
    initBestSellersCountdown(event.target);
  });

  document.querySelectorAll('.wig-spotlight__form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!window.fetch || !window.WigCart) return;
      event.preventDefault();

      const submit = form.querySelector('[type="submit"]');
      const variantInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      const variantId = variantInput?.value;
      if (!variantId || submit?.disabled) return;
      if (submit?.getAttribute('data-server-available') === 'false') return;

      const originalLabel = submit?.textContent;
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding...';
      }

      try {
        await window.WigCart.addVariant(variantId, 1);
      } catch (err) {
        console.error(err);
        if (submit) submit.textContent = err.message || 'Could not add to cart';
        window.setTimeout(() => {
          if (submit && originalLabel) submit.textContent = originalLabel;
        }, 2500);
      } finally {
        if (submit && !submit.classList.contains('is-sold-out')) {
          submit.disabled = false;
          if (submit.textContent === 'Adding...' && originalLabel) submit.textContent = originalLabel;
        }
      }
    });
  });
})();
